import React from "react";

export interface IconSwitchProps {
  open: boolean;
  collapseImage: string;
  expandImage: string;
}

const IconSwitch: React.FC<IconSwitchProps> = ({
  open = false,
  collapseImage = "",
  expandImage = ""
}) => {
  return <>{open ? <img src={expandImage} alt=" " /> : <img src={collapseImage} alt=" "/>}</>;
};

export default IconSwitch;
